import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CompanyDTO from '../dtos/CompanyDTO';
import Person from '../dtos/PersonDTO';
import { CustomerType } from '../enums/customerType';

interface Props {
  type: CustomerType;
  company?: CompanyDTO;
  person?: Person;
}

const SubjectInfo = ({ type, company, person }: Props) => {
  // translations
  const tLabels = useTranslation("customer\\customer").t;

  if (type === CustomerType.Company) {
    return (
      <>
        <div className="small">
          <span className="text-muted mr-2">{tLabels("subjectInfo.companyRegistrationNumber")}:</span>
          <span>{company?.companyRegistrationNumber}</span>
        </div>
        <div className="small">
          <span className="text-muted mr-2">{tLabels("subjectInfo.taxId")}:</span>
          <span>{company?.taxId || "-"}</span>
        </div>
      </>
    );
  } else if (type === CustomerType.Person) {
    return (
      <div className="small">
        <span className="text-muted mr-2">{tLabels("subjectInfo.dateOfBirth")}:</span>
        <span>
          <DateFormatter date={person?.dateOfBirth!} />
        </span>
      </div>
    );
  } else {
    return null;
  }
}

export default SubjectInfo;
